/**
 * Paths owned by the authenticated app shell. On these, App.js routing
 * (including the needsWizard onboarding redirect) already decides where the
 * user lands, so a post-login navigation to '/' is unnecessary and could
 * fight that logic. Public/static pages (/privacy, /salgsvilkar, /about,
 * /contact, /status, ...) are deliberately NOT listed — a user who logs in
 * from one of those would otherwise be stranded outside the app layout.
 */
const APP_ROUTE_PREFIXES = [
  '/home',
  '/dashboard',
  '/onboarding',
  '/conversations',
  '/new-conversation',
  '/resources',
  '/soknad',
  '/account',
  '/profile',
];

/**
 * @param {string} pathname - window.location.pathname / location.pathname
 * @returns {boolean} true if App.js routing already handles this path post-login
 */
export const isAppRoute = (pathname) => {
  if (!pathname || pathname === '/') return true;
  return APP_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};
